import { html } from 'lit';
import { t } from '../i18n';
import { surfaceOf } from './sign';

/**
 * "I don't know — show me" (v1 ticket 46): a scored miss the learner asks for, with the answer shown at once. A view
 * offers it by putting `giveup` on the card's surface (every scored card: not practice's study mode). A card sends its
 * ordinary wrong answer with `gaveUp: true` in the context, which only the views read (the answer stays on screen).
 */
export function giveUpOffered(el: Element): boolean {
  return surfaceOf(el)?.hasAttribute('giveup') === true;
}

/** The quiet button under a card's own actions. */
export function giveUpButton(onTap: () => void) {
  return html`<button class="give-up" @click=${onTap}>${t('ex.dontKnow')}</button>`;
}
